// @flow

import React from "react";
import { localize } from "redux-i18n";
import moment from "moment";
import { Button, DatePicker, View } from "@components";
import type { OutcomesReportFiltersType } from "@modules/reporting/reducer/referral-tracker/types";

type OwnProps = $Exact<{
  filters: OutcomesReportFiltersType,
  onExport: () => void,
  onSubmitFilters: () => void,
  setFilters: (newFilters: OutcomesReportFiltersType) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

const OutcomesReportFilters = (props: Props) => {
  const { t, filters, setFilters } = props;

  const onDateChange = (fieldName: string) => (value: string) => {
    const newFilters = {
      ...filters,
      [fieldName]: value.length ? moment(value).format("YYYY-MM-DD") : "",
    };

    setFilters(newFilters);
  };

  return (
    <View direction="row" justifyContent="space-between">
      <View direction="row">
        <View direction="row" alignItems="center" gap={1} margin={[0, "1rem", 0, 0]}>
          <span className="text-color-charcoal mr-2">{t("FROM")}:</span>
          <DatePicker value={filters.fromDate} onChange={onDateChange("fromDate")} />
        </View>

        <View direction="row" alignItems="center" gap={1} margin={[0, "1rem", 0, 0]}>
          <span className="text-color-charcoal mr-2">{t("TO")}:</span>
          <DatePicker value={filters.toDate} onChange={onDateChange("toDate")} />
        </View>
        <Button materialIcon="replay_circle_filled" onClick={props.onSubmitFilters}>
          {t("SUBMIT")}
        </Button>
      </View>
      <Button materialIcon="file_download" onClick={props.onExport}>
        {t("EXPORT")}
      </Button>
    </View>
  );
};

export default localize()(OutcomesReportFilters);
